import { useLang } from "@/LangContext";

export default function Marquee() {
  const { lang, t } = useLang();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-white/10 bg-[#0C0F16] py-5"
    >
      <div className="marquee-track" key={lang}>
        {items.map((item, i) => (
          <span key={i} className="flex shrink-0 items-center gap-8 pr-8">
            <span className="whitespace-nowrap font-code text-xs uppercase tracking-[0.4em] text-slate-400">
              {item}
            </span>
            <span className="text-amber-400/70">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
